export default [
  '$window',
  class FooterController {
    constructor($window) {
      this.year = $window.moment(new Date()).format('YYYY');
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/layout-components/footer/footer.ctrl.js